/**
 * WizardStep2Cert — Krok 2: Upload certyfikatu, klucza i hasła (3 osobne sekcje).
 *
 * Refaktor 2026-06-01: zamiast jednego formularza z opcjonalnymi polami,
 * 3 niezależne sekcje (cert / klucz / hasło) z osobnymi buttonami "Zapisz".
 *
 * Walidacja przejścia do kroku 3:
 *   has_cert && key_filename && has_key_password
 *
 * Props:
 *   - adminConfig (object)
 *   - savedNip (string)
 *   - onCompleted (callback) — wywoływane gdy WSZYSTKIE 3 elementy zapisane
 *   - onChanged (callback)   — refresh adminConfig po każdym save
 */
import { useEffect } from "react";
import { FileCheck } from "lucide-react";
import { CertFileForm } from "../components/CertFileForm";
import { KeyFileForm } from "../components/KeyFileForm";
import { KeyPasswordForm } from "../components/KeyPasswordForm";

export const WizardStep2Cert = ({ adminConfig, savedNip, onCompleted, onChanged }) => {
  const allReady =
    !!adminConfig?.has_cert &&
    !!adminConfig?.key_filename &&
    !!adminConfig?.has_key_password;

  useEffect(() => {
    if (allReady && onCompleted) onCompleted();
  }, [allReady]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSaved = () => {
    if (onChanged) onChanged();
  };

  return (
    <div className="space-y-4" data-testid="wizard-step2">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <FileCheck className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-[#0F1F3D]">Krok 2: Certyfikat KSeF</h2>
        </div>
        <p className="text-sm text-gray-600">
          Wgraj <strong>certyfikat</strong>, <strong>klucz prywatny</strong> i ustaw{" "}
          <strong>hasło</strong>. Zapisuj każdy element osobno — po każdym zapisie zobaczysz
          potwierdzenie. Używaj certyfikatu typu "Uwierzytelnienie (do API)" pobranego z portalu KSeF.
        </p>
      </div>

      <CertFileForm adminConfig={adminConfig} onSaved={handleSaved} />
      <KeyFileForm adminConfig={adminConfig} onSaved={handleSaved} />
      <KeyPasswordForm adminConfig={adminConfig} onSaved={handleSaved} />

      {allReady && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-green-800">
          ✅ Wszystkie elementy konfiguracji są zapisane. Możesz przejść do kroku 3 (test połączenia).
        </div>
      )}
    </div>
  );
};

export default WizardStep2Cert;
